<template>
  <div class="page-content">
    <el-row class="operation">
      <el-button @click="goBack" type="info">返回</el-button>
      <el-button type="primary" @click="edit" v-if="routeData && routeData.desc === 'view'">编辑</el-button>
    </el-row>
    <!-- 基本信息 -->
    <el-row class="marg">
      <BasicInfo ref="basic" :basicData="basicData" :disabledFlag="disabledFlag" :selStatus="routeData.desc"
        :allImgList="allImgList" />
    </el-row>
    <!-- 添加方式 -->
    <el-row class="marg">
      <AddType ref="add" :addTypeData="addTypeData" :disabledFlag="disabledFlag" :selStatus="routeData.desc"
        :allImgList="allImgList" />
    </el-row>
    <!-- 连接方式 -->
    <el-row class="marg">
      <ConnectType ref="connect" :connectData="connectData" :disabledFlag="disabledFlag" />
    </el-row>
    <!-- 成功提示 -->
    <!-- <el-row class="marg">
      <Success ref="success" :successData="successData" :disabledFlag="disabledFlag" :allImgList="allImgList" />
    </el-row> -->
    <!-- 失败提示 -->
    <el-row class="marg">
      <Died ref="die" :failData="failData" :disabledFlag="disabledFlag" :allImgList="allImgList" />
    </el-row>
    <!-- 备注 -->
    <el-row style="marg">
      <el-card>
        <h3 class="title">备注</h3>
        <el-form label-position="left" ref="ruleForm" :model="form" :disabled="disabledFlag">
          <el-form-item label="备注" label-width="120px">
            <el-col :span="12">
              <el-input :autosize="{ minRows: 3, maxRows: 3 }" v-model="form.remarks" :maxlength="255" type="textarea"
                placeholder="文字限制255个字符内" class="add1TextArea" />
            </el-col>
          </el-form-item>
        </el-form>
      </el-card>
    </el-row>
    <!-- 提交按钮 -->
    <el-row style="text-align:center; margin-top:10px" v-if="routeData && routeData.desc !== 'view'">
      <el-button type="primary" @click="handlerClick('update')"
        v-if="routeData && routeData.desc === 'edit'">确认并修改该引导页</el-button>
      <el-button type="primary" @click="handlerClick('add')" v-else>确认并添加该引导页</el-button>
    </el-row>
  </div>
</template>
<script>
// TODO: 需进行优化 父子组件上传问题
import BasicInfo from '@/components/categoryManager/basicInfo'
import AddType from '@/components/categoryManager/addType'
import ConnectType from '@/components/categoryManager/connectType'
import Success from '@/components/categoryManager/successMessage'
import Died from '@/components/categoryManager/diedMessage'
import { addGuide, guideDetail, updateGuide } from '@/api/appGuide'
// import { guideDetail, updateGuide } from '@/api/appGuide'
import { deleteImg } from '@/api/fileServer'
export default {
  components: {
    BasicInfo,
    AddType,
    ConnectType,
    Success,
    Died
  },
  data() {
    return {
      routeData: null,
      form: {
        remarks: ''
      },
      tableHeight: 600,
      basicData: {
        categoryId: '',
        productBrand: '',
        productModel: '',
        productPic: '',
        picName: '',
        productUrl: ''
      },
      allImgList: [], // 用于专门接收删除的图片数组
      addTypeData: {
        addType: 0,
        guideStepInfoDtoList: [
          {
            picTitle: '', // 标题
            // picToken: '', // 文件key
            picDesc: '', // 步骤提示语
            stepOrder: 1, // 步骤顺序
            stepName: '第1步', // 步骤名称
            // picName: '',
            // picUrl: '',

            guideStepImageDtoList: [],
            // guideStepImageDtoList: [
            //   {
            //     "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
            //     "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
            //     "picName": "1.jpg"
            //   },
            //   {
            //     "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/21502b2d7b0648d298beb599e1df6ae4.jpg?Expires=1714880376&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=YuljrnxnxdwgeIUYPD5Aw2rD7xw%3D",
            //     "picToken": "appGuide/img/20240428/21502b2d7b0648d298beb599e1df6ae4.jpg",
            //     "picName": "3.jpg"
            //   },
            //   {
            //     "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/28cb87974d5d4a54ad2e23fce26b93a3.png?Expires=1714880488&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=ZXwaKWdTDwO%2B87NeIXrbNElgOI4%3D",
            //     "picToken": "appGuide/img/20240428/28cb87974d5d4a54ad2e23fce26b93a3.png",
            //     "picName": "4.png"
            //   }
            // ],
            itemId: new Date().valueOf()
          },
          // {
          //   picTitle: '', // 标题
          //   picToken: '', // 文件key
          //   picDesc: '', // 步骤提示语
          //   stepOrder: 2, // 步骤顺序
          //   stepName: '第2步', // 步骤名称
          //   guideStepImageDtoList: [],
          //   // guideStepImageDtoList: [
          //   //   {
          //   //     "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
          //   //     "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
          //   //     "picName": "1.jpg"
          //   //   },
          //   // ],
          //   picName: '',
          //   picUrl: '',
          //   itemId: new Date().valueOf()
          // }
        ]
      },
      connectData: {
        overTime: '',
        button: '',
        countdownType: 0
      },
      // successData: {
      //   picTitle: '', // 标题
      //   picToken: '', // 文件key
      //   picDesc: '', // 步骤提示语
      //   stepOrder: -1, // 步骤顺序
      //   stepName: '成功', // 步骤名称
      //   picName: '',
      //   picUrl: '',
      //   guideStepImageDtoList: [],

      //   guideStepImageDtoList: [
      //     {
      //       "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
      //       "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
      //       "picName": "1.jpg"
      //     },
      //   ],
      // },
      failData: {
        picTitle: '', // 标题
        picToken: '', // 文件key
        picDesc: '', // 步骤提示语
        stepOrder: -2, // 步骤顺序
        stepName: '失败', // 步骤名称
        picName: '',
        picUrl: '',
        guideStepImageDtoList: [],
        // guideStepImageDtoList: [
        //   {
        //     "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
        //     "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
        //     "picName": "1.jpg"
        //   },
        // ],
      },
      disabledFlag: false,
      validateResult: false,

      // allData: [{}]
    }
  },
  watch: {
    allImgList: {
      handler(val) {
        console.log(val.length)
      }
    }
  },
  created() {
    if (JSON.parse(this.$route.query.obj)) {
      this.routeData = JSON.parse(this.$route.query.obj)
    }
    if (this.routeData.desc === 'view') {
      this.disabledFlag = true
      const guideIdOrProductKey = this.routeData.guideIdOrProductKey
      guideDetail({
        params: {
          guideIdOrProductKey
        }
      }).then(res => {
        const result = res.data.data
        // 分割数据
        this.$nextTick(() => {
          // this.basicData.picName = result.picName;
          // this.basicData.categoryId = result.categoryId
          // this.basicData.productBrand = result.productBrand
          // this.basicData.productModel = result.productModel
          // this.basicData.productPic = result.productPic
          // this.basicData.productUrl = result.productUrl
          this.basicData = {};
          this.basicData.productId = result.productId;
          this.basicData.productKey = result.productKey;
          this.basicData.productName = result.productName;

          this.connectData.overTime = result.overTime;
          this.connectData.button = result.button;
          this.connectData.countdownType = result.countdownType;
          this.addTypeData.addType = result.addType;
          this.allImgList.push(result.productPic);

          // 进行排序
          result.appGuideFileVos.sort(function (a, b) {
            return a.stepOrder - b.stepOrder
          })
          // 添加到需要删除的图片数组
          result.appGuideFileVos.forEach((ele) => {
            this.allImgList.push(ele.picToken)
          })
          /* ----- */
          // this.successData = result.appGuideFileVos.find((item, index) => {
          //   item.appGuideSubVoList.forEach(itemK => {
          //     let { picToken, picUrl } = itemK;
          //     itemK.url = picUrl;
          //     itemK.name = picToken;
          //   })
          //   return item.stepOrder === -1
          // })
          // let { picUrl: picUrlSuccess, picToken: picTokenSuccess } = this.successData.appGuideSubVoList[0];
          // this.successData.picUrl = picUrlSuccess;
          // this.successData.picToken = picTokenSuccess;
          // this.successData.appGuideSubVoList[0] = {
          //   "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
          //   "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
          //   "picName": "1.jpg"
          // }
          /* ----- */
          this.failData = {};
          let failPicUrl = '';
          let failPicToken = '';
          this.failData = result.appGuideFileVos.find((item, index) => {
            item.appGuideSubVoList.forEach(itemK => {
              let { picToken, picUrl } = itemK;
              itemK.url = picUrl;
              itemK.name = picToken;
              failPicUrl = picUrl;
              failPicToken = picToken;
            })
            item.guideStepImageDtoList = item.appGuideSubVoList;
            return item.stepOrder === -2
          })
          this.failData.picUrl = failPicUrl;
          this.failData.picToken = failPicToken;
          // this.failData.appGuideSubVoList[0] = {
          //   "picUrl": "https://xliot-dev.oss-cn-shenzhen.aliyuncs.com/appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg?Expires=1714880370&OSSAccessKeyId=LTAI4G4ZdYTdQYDzbpK4xu6V&Signature=NAghwTtbcTISdE5idP4cMJgyTw8%3D",
          //   "picToken": "appGuide/img/20240428/a229acc7987c4756b8e6a280328d2e03.jpg",
          //   "picName": "1.jpg"
          // }
          let xx = this.failData;
          debugger;
          const result1 = result.appGuideFileVos.slice(1);
          this.addTypeData.guideStepInfoDtoList = result1.map(item => {
            item.appGuideSubVoList.forEach(itemK => {
              let { picToken, picUrl } = itemK;
              itemK.url = picUrl;
              itemK.name = picToken;
            })
            item.guideStepImageDtoList = item.appGuideSubVoList;
            item.itemId = new Date().valueOf()
            return item
          })
          this.form.remarks = result.remarks;
          this.$forceUpdate();
        })
      })
    }


  },
  methods: {

    handlerClick(val) {
      console.log(this.connectData)
      // 对5个表单进行同时验证
      const basic = this.$refs.basic.$refs.ruleForm
      const add = this.$refs.add.$refs.ruleForm
      const connect = this.$refs.connect.$refs.ruleForm
      // const success = this.$refs.success.$refs.ruleForm
      const die = this.$refs.die.$refs.ruleForm
      debugger;
      Promise.all([basic, add, connect, die].map(this.getFormPromise)).then(res => {
        // this.delImgList()
        const validateResult = res.every(item => item) // item为True则通过
        if (validateResult) {
          // console.log('两个表单都校验通过')
          // 合并数据
          const obj = {}
          const arr = this.addTypeData.guideStepInfoDtoList.slice()
          // arr.push(this.successData)
          arr.push(this.failData)
          obj.guideStepInfoDtoList = arr
          obj.addType = this.addTypeData.addType
          const params = Object.assign({}, this.basicData, this.connectData, obj)
          params.remarks = this.form.remarks;
          if (val === 'update') {
            params.guideId = this.routeData.guideId
            params.guideStepInfoDtoList.forEach(item => {
              if (item.updateGuideStepImageDtos) {
                let uploadImgs = item.updateGuideStepImageDtos.map(item => {
                  let { picName, picToken } = item;
                  return {
                    picName, picToken
                  }
                })
                item.updateGuideStepImageDtos = uploadImgs;
                // delete item.appGuideSubVoList;
                // delete item.guideStepImageDtoList;
              } else {
                debugger;
                let uploadImgs = item.guideStepImageDtoList.map(item1 => {
                  let { picName, picToken } = item1;
                  return {
                    picName, picToken
                  }
                });
                item.updateGuideStepImageDtos = uploadImgs;
              }
            })
            updateGuide({ params }).then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '编辑成功'
                })
                setTimeout(() => {
                  this.goBack()
                }, 500)
              }
            }).catch((err) => {
              this.$message({
                type: 'error',
                message: err.data.message
              })
            })
          } else {
            addGuide({ params }).then(res => {
              if (res.data.code === 200) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                setTimeout(() => {
                  this.goBack()
                }, 500)
              }
            }).catch((err) => {
              this.$message({
                type: 'error',
                message: err.data.message
              })
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: '表单校验不通过,请补全表单后再试'
          })
        }
      })
    },
    edit() {
      this.routeData.desc = 'edit'
      this.disabledFlag = false
    },
    // promise all
    getFormPromise(form) {
      return new Promise(resolve => {
        form.validate(res => {
          resolve(res)
        })
      })
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },
    // 删除图片接口
    delImgList() {
      const picTokens = [] // 添加保留imgToken如数组
      picTokens.push(this.basicData.productPic)
      // picTokens.push(this.successData.picToken)
      picTokens.push(this.failData.picToken)
      this.addTypeData.guideStepInfoDtoList.forEach((e, index) => {
        picTokens.push(e.picToken)
      })
      // 进行需要删除的图片处理操作
      const result = this.allImgList.filter((item) => {
        return picTokens.indexOf(item) === -1
      })
      if (result.length > 0) {
        // TODO: 调用删除图片接口
        const params = Object.assign([], result)
        deleteImg({ params }).then((res) => {
          if (res.data.code === 200) {
            console.log('多余图片删除成功')
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
.page-content {
  .el-card {
    padding: 14px;
  }

  /deep/ .el-card__body {
    padding: 0;
  }

  .marg {
    margin-bottom: 10px
  }

  .operation {
    margin-bottom: 20px;
  }

  .title {
    width: 10%;
    padding: 5px 5px 5px 0;
    display: inline-block;
    margin-bottom: 10px;
    border-bottom: 1px solid #e6e2e2;
  }
}
</style>
